import { useCallback, useMemo } from 'react';

import { useGraphql } from '../graphql';
import { useLoad } from '../load';

// The Tests section's two lists in one request: what is assigned now, with
// any draft's answers so the card can count them, and everything submitted.
// tests is undefined until the answer arrives or when it failed; error and
// retry are useLoad's.
export function useTests() {
  const graphql = useGraphql();

  const read = useCallback(function() {
    return graphql({
      document: `query Tests {
        assignments {
          id assignedBy dueDate instructions repeatEveryDays
          questionnaire { name items { position } }
          draft { id answers { position } }
        }
        submittedAttempts { id submittedAt questionnaire { name } }
      }`
    }).then(function(data) {
      return { assigned: data.assignments, submitted: data.submittedAttempts };
    });
  }, [ graphql ]);

  const { data, error, retry } = useLoad(read);

  return useMemo(function() {
    return { tests: data, error, retry };
  }, [ data, error, retry ]);
}
